// extracted by mini-css-extract-plugin
export default {"link":"BookmarksPage_link__qtZP0"};